"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIORITY_TO_LOCALIZATION_MESSAGE_KEY = exports.STATUS_TO_LOCALIZATION_MESSAGE_KEY = exports.HLQATasksColumns = void 0;
const graphql_1 = require("../../../../../__generated__/graphql");
var HLQATasksColumns;
(function (HLQATasksColumns) {
    HLQATasksColumns["LastReviewedAt"] = "lastReviewedAt";
    HLQATasksColumns["Status"] = "status";
    HLQATasksColumns["EscalationReason"] = "escalationReason";
    HLQATasksColumns["Task"] = "task";
    HLQATasksColumns["TerminalNode"] = "nodeTitle";
    HLQATasksColumns["Attribute"] = "label";
    HLQATasksColumns["Priority"] = "priority";
    HLQATasksColumns["L1NodeTitle"] = "l1NodeTitle";
    HLQATasksColumns["TotalProducts"] = "totalProducts";
    HLQATasksColumns["AssignedTo"] = "assignedTo";
    HLQATasksColumns["ReviewedBy"] = "reviewedBy";
    HLQATasksColumns["ProductsReviewed"] = "productsReviewed";
    HLQATasksColumns["PercentReviewed"] = "percentReviewed";
    HLQATasksColumns["TaskCount"] = "taskCount";
    HLQATasksColumns["InstructionsUpdatedAt"] = "instructionsUpdatedAt";
    HLQATasksColumns["NumberOfCorrections"] = "numberOfCorrections";
    HLQATasksColumns["NotApplicable"] = "notApplicable";
    HLQATasksColumns["Unknown"] = "unknown";
    HLQATasksColumns["CorrectionsCount"] = "correctionEventsCount";
    HLQATasksColumns["CorrectionsPercentage"] = "correctionsPercent";
    HLQATasksColumns["TotalCorrectionsPercentage"] = "totalCorrectionsPercent";
    HLQATasksColumns["View"] = "viewTask";
})(HLQATasksColumns || (exports.HLQATasksColumns = HLQATasksColumns = {}));
exports.STATUS_TO_LOCALIZATION_MESSAGE_KEY = {
    [graphql_1.PriorityTaskStatus.NotStarted]: 'HLQA_STATUS_NOT_STARTED',
    [graphql_1.PriorityTaskStatus.InProgress]: 'HLQA_STATUS_IN_PROGRESS',
    [graphql_1.PriorityTaskStatus.Reviewed]: 'HLQA_STATUS_REVIEWED',
    [graphql_1.PriorityTaskStatus.Escalated]: 'HLQA_STATUS_ESCALATED',
};
exports.PRIORITY_TO_LOCALIZATION_MESSAGE_KEY = {
    [graphql_1.PriorityTasksPriority.P1]: 'HLQA_PRIORITY_BLOCKER',
    [graphql_1.PriorityTasksPriority.P2]: 'HLQA_PRIORITY_CRITICAL',
    [graphql_1.PriorityTasksPriority.P3]: 'HLQA_PRIORITY_MAJOR',
    [graphql_1.PriorityTasksPriority.P4]: 'HLQA_PRIORITY_NORMAL',
    [graphql_1.PriorityTasksPriority.P5]: 'HLQA_PRIORITY_MINOR',
};
